import { createContext, useContext, type ReactNode } from 'react';
import type { ApiClient } from '../api/client';
import type { ApiMode } from '../api/mode';

export interface Platform {
  api: ApiClient;
  /** 'fixture' を選んでいることを画面に出すために保持する。実API障害時の自動切替はしない。 */
  mode: ApiMode;
  /** localは固定のPrincipal。ログイン/ユーザー切替のUIは作らない。 */
  actorId: 'local-user';
}

const PlatformContext = createContext<Platform | null>(null);

export function PlatformProvider(props: { value: Platform; children: ReactNode }) {
  return <PlatformContext value={props.value}>{props.children}</PlatformContext>;
}

export function usePlatform(): Platform {
  const platform = useContext(PlatformContext);
  if (!platform) throw new Error('PlatformProviderの外でusePlatformを呼びました');
  return platform;
}
